import React from "react";
import { Card } from '@curves/ui-base';

import { ConsumerSectionByRead, InvoiceSectionByRead, PaymentSectionByRead, ProductSectionByRead, ReceiverSectionByRead, ClubSection } from "../Main";
import { SuspensionSectionByRead, QuitSectionByRead } from "../Main";
import { isEqual } from "@Util/utils";
import { CYCLEORDER_TYPE } from "@Constants/";
const CyclePurchaseDetailMain = props => {
	const { detailData } = props;
	const { cycleOrderType } = detailData || {};
	return (
		<Card className="p-4">
			<Card.CardContent>
				{isEqual(cycleOrderType, CYCLEORDER_TYPE.PAUSEORDER) || isEqual(cycleOrderType, CYCLEORDER_TYPE.UNSUBSCRIBEORDER) ? (
					<Card className="order-info-card mb-4">
						{isEqual(cycleOrderType, CYCLEORDER_TYPE.PAUSEORDER) && (
							<SuspensionSectionByRead
								title="暫停資訊"
								titleClassName="bg-error-light"
								suspendStartDate={detailData?.suspendStartDate}
								suspendEndDate={detailData?.suspendEndDate}
								suspendReasonText={detailData?.suspendReasonText}
								suspendNote={detailData?.suspendNote}
							/>
						)}
						{isEqual(cycleOrderType, CYCLEORDER_TYPE.UNSUBSCRIBEORDER) && (
							<QuitSectionByRead
								title="退訂資訊"
								titleClassName="bg-error-light"
								unsubscribeDate={detailData?.unsubscribeDate}
								unsubscribeReasonText={detailData?.unsubscribeReasonText}
								unsubscribeNote={detailData?.unsubscribeNote}
							/>
						)}
					</Card>
				) : null}
				<ConsumerSectionByRead
					clubName={detailData?.clubName}
					memberName={detailData?.memberName}
					cellPhone={detailData?.cellPhone}
					memberNo={detailData?.memberNo}
					birthday={detailData?.birthday}
				/>
				<ProductSectionByRead items={detailData?.items} />
				<ReceiverSectionByRead
					receiverName={detailData?.receiverName}
					receiverMobile={detailData?.receiverMobile}
					receiverAddress={detailData?.receiverAddress}
					receiverNotes={detailData?.receiverNotes}
				/>
				<PaymentSectionByRead payment={detailData?.payment} />
				<InvoiceSectionByRead invoice={detailData?.invoice} />
				<ClubSection clubName={detailData?.clubName} saleClubName={detailData?.saleClubName} employeeName={detailData?.employeeName} />
			</Card.CardContent>
		</Card>
	);
};
export default CyclePurchaseDetailMain;
